import { SiteDropdownOption } from "./site-dropdown-option.model";

export class SiteDropdownChanged extends SiteDropdownOption {
  public displayValue: string;

  public static create(option: SiteDropdownOption, displayValue: string) {
    let changed = new SiteDropdownChanged(option);
    changed.displayValue = displayValue;
    return changed;
  }
}
